var React = require('react');

function Id (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"#e70011","d":"M0 0h640v249H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 240h640v240H0z","key":1})]));
}

Id.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Id;

Id.default = Id;
